// imports
import { formatDate } from '$utils/Utils.js';

export function date(value, format) {
	return formatDate(value, format);
}

export default { date };
